import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { styles as dsStyles } from '@frontend/design-system';

export const styles = {
  popoverDialog: css`
    overflow: hidden;
    max-width: 240px;
    min-width: 240px;
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-padding-xs);
  `,
  tagsList: [
    css`
      display: flex;
      flex-wrap: wrap;
      gap: var(--fabric-space-padding-xxs);
      max-height: 124px;
      overflow-y: auto;
      align-content: flex-start;
      align-items: flex-start;
    `,
    dsStyles.smallScrollbar(theme),
  ],
  tagChip: css`
    padding: var(--fabric-space-padding-none) var(--fabric-space-padding-xxs);
    font-size: var(--fabric-typography-body-xs-font-size);
    font-weight: var(--fabric-typography-body-xs-font-weight);
  `,
  emptyState: css`
    width: 100%;
    padding-bottom: var(--fabric-space-padding-xs);
  `,
  actionsRow: css`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  `,
  createTagButton: css`
    display: flex;
    align-items: center;
    gap: var(--fabric-space-padding-xxs);
    height: var(--fabric-number-n-6);
    border-radius: var(--fabric-radius-sm);
    border: 0.5px solid var(--fabric-color-blue-50);
    padding: 0 var(--fabric-space-padding-xxs);
    cursor: pointer;
  `,
  createTagText: css`
    line-height: var(--fabric-typography-body-xs-line-height);
    font-size: var(--fabric-typography-body-xs-font-size);
    font-weight: var(--fabric-typography-body-xs-font-weight);
    color: var(--fabric-color-blue-50);
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  settingsButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--fabric-space-padding-xxs);
    border-radius: var(--fabric-radius-sm);
    margin-left: auto;

    :hover {
      background-color: var(--fabric-color-neutral-5);
    }
  `,
};
